import { useQuery } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

interface Props {
  from?: string | null;
  to?: string | null;
  companyId?: string;
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string | string[];
}

export const useCompaniesDetailedList = ({
  from,
  to,
  companyId,
  pageNumber,
  pageSize,
  sortBy
}: Props) => {
  const queryParams = new URLSearchParams();
  if (from) queryParams.append('from', from);
  if (to) queryParams.append('to', to);
  if (pageNumber) queryParams.append('pageNumber', pageNumber.toString());
  if (pageSize) queryParams.append('pageSize', pageSize.toString());
  if (companyId) queryParams.append('companyId', companyId);
  if (sortBy) {
    if (Array.isArray(sortBy)) {
      sortBy.forEach((sort) => queryParams.append('sortBy', sort));
    } else {
      queryParams.append('sortBy', sortBy);
    }
  }
  const queryString = queryParams.toString();

  return useQuery({
    queryKey: ['company/detailed-list', from, to, companyId, pageNumber, pageSize, sortBy],
    queryFn: async () => {
      const response: iResponse<Pagination<NegotiatorDetailed>> = await fetchAPI({
        method: 'GET',
        route: 'company/detailed-list',
        queryString
      });
      return response;
    },
    enabled: !!from && !!to
  });
};

export default useCompaniesDetailedList;
